export default function getStarLabel(rating: number, locale: "USA" | "BRA"): string {
  if (locale === "USA") {
    if (rating === 1) {
      return "Poor";
    }

    if (rating === 2) {
      return "Bad";
    }

    if (rating === 3) {
      return "Fair";
    }

    if (rating === 4) {
      return "Good";
    }

    if (rating === 5) {
      return "Great";
    }
  }

  if (locale === "BRA") {
    if (rating === 1) {
      return "Péssima";
    }

    if (rating === 2) {
      return "Ruim";
    }

    if (rating === 3) {
      return "Regular";
    }

    if (rating === 4) {
      return "Boa";
    }

    if (rating === 5) {
      return "Ótima";
    }
  }

  return "";
}
